export default "__VITE_ASSET__BeLSt3QA__"